// extracted by mini-css-extract-plugin
export var button = "_3r-7";
export var buttonRow = "_3r-6";
export var fadeIn = "_3r-1";
export var gradient = "_3r-0";
export var panel = "_3r-2";
export var panelIn = "_3r-3";
export var subtitle = "_3r-5";
export var title = "_3r-4";